const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Akash Chauhan</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Cinematography Head, UPES-CSI</li>
    <li>
        Expert in video production and cinematography.
    </li>
    <li>
        Capturing memorable moments at CSI events.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
